export enum REPORT_TYPE {
  DAILY = "daily",
  TREND = "trend",
}

export const ACTIVITY_SESSION_TYPE = {
  ACTIVITY: "activity",
  SESSION: "session",
}
export type ACTIVITY_SESSION_TYPE =
  (typeof ACTIVITY_SESSION_TYPE)[keyof typeof ACTIVITY_SESSION_TYPE]

export const SECTION_TYPE = {
  UNKNOWN: "unknown",

  // daily
  SUMMARY: "summary",
  GRAPH: "graph",
  SESSION_DETAILS: "sessionDetails",
  STATS: "stats",
  SCATTER_GRAPH: "scatterGraph",

  // trend
  ACTIVITY_GRAPH: "activityGraph",
  ACTIVITY_STATS: "activityStats",
  PLAYER_GRAPH: "playerGraph",
  PLAYER_STATS: "playerStats",
  CUSTOM_TABLE: "customTable",

  // new
  TACTIC_MAP: "tacticMap",
  PERFORMANCE_PROFILE: "performanceProfile",
}

export type SECTION_TYPE = (typeof SECTION_TYPE)[keyof typeof SECTION_TYPE]

export const CHART_TYPE = {
  BAR: "bar",
  STACKED_BAR: "stacked",
  POINT: "point",
  LINE: "line",
  AREA: "area",
}
type CHART_TYPE = (typeof CHART_TYPE)[keyof typeof CHART_TYPE]

// 값을 표시하는 위치와 방법
export enum VALUE_POSITION_TYPE {
  HIDE_VALUES = "HIDE_VALUES", // 표시 하지 않음
  ABOVE = "ABOVE", // 차트 상단에 테이블 형태로 값 표시
  BELOW = "BELOW", // 차트 하단에 테이블 형태로 값 표시
  IN_CHART_IN_ORDER = "IN_CHART_IN_ORDER", // 차트 내부에 값 표시(순서대로 표시)
  IN_CHART_EACH_POSITION = "IN_CHART_EACH_POSITION", // 차트 내부에 값 표시(각 차트의 모든 값 표시)
  IN_CHART_EACH_POSITION_MIN_MAX = "IN_CHART_EACH_POSITION_MIN_MAX", // 차트 내부에 값 표시(각 차트의 최소, 최대 값만 표시)
  IN_BAR = "IN_BAR", // 막대 안(위쪽)에 값 표시 — 누적 막대는 조각마다, 선·점은 옆에 (PDF 빌더 "In chart", #185)
}

// 값에 표시할 장식
export enum VALUE_ORNAMENT_TYPE {
  NONE, // 기본 색상 사용
  USE_CHART_COLOR, // 차트 색상 사용
  USE_CHART_COLOR_DARK, // 차트 색상 사용(어두운 색상)
}

export const DRAWER_WIDTH = 240
export const REPORT_PADDING = 56
export const REPORT_SECTION_PADDING = 40

export const ORDINAL_STRINGS = ["1st", "2nd", "3rd"]
export const DEFAULT_PLAYER_NAME_SORT_OPTIONS = [
  {
    name: "A - Z",
    value: "playerNameAZ",
  },
  {
    value: "playerNameZA",
    name: "Z - A",
  },
]
export const DEFAULT_SESSION_NAME_SORT_OPTIONS = [
  {
    name: "A - Z",
    value: "sessionNameAZ",
  },
  {
    value: "sessionNameZA",
    name: "Z - A",
  },
]
export const DEFAULT_EXPORT_OPTIONS = [
  {
    value: "pdf",
    name: "PDF",
    group: "button.export",
  },
  {
    value: "png",
    name: "PNG Image",
    group: "button.export",
  },
]
export const DEFAULT_CSV_OPTIONS = [
  {
    value: "statsCsv",
    name: "Stats (CSV)",
    group: "button.export",
  },
]

export const EXPORT_TYPE = {
  PDF: "pdf",
  RAW_DATA: "rawData",
  REPORT_BUILDER: "reportBuilder",
} as const

export type ExportTypeValue = (typeof EXPORT_TYPE)[keyof typeof EXPORT_TYPE]

export const DEFAULT_EXPORT_TYPE = [
  {
    value: EXPORT_TYPE.PDF,
    label: "PDF or Print",
  },
  {
    value: EXPORT_TYPE.RAW_DATA,
    label: "Raw Data (CSV)",
  },
  {
    value: EXPORT_TYPE.REPORT_BUILDER,
    label: "Report Builder",
  },
]

export const DECIMAL_POINT_ITEMS = [
  {
    value: 1,
    label: "0.1",
  },
  {
    value: 2,
    label: "0.01",
  },
  {
    value: 3,
    label: "0.001",
  },
]

export const DIVE_METRICS = ["rightDiveCount", "leftDiveCount", "totalDiveCount"]

export const DEFAULT_SELECTED_METRIC_KEY_LIST = [
  "duration",
  "totalDistance",
  "totalDistancePerMinute",
  "maxSpeed",
  "totalSpeedPerMinute",
  "runEffort2Distance",
  "runEffort1Distance",
  "runEffort2Count",
  "runEffort1Count",
  "accelEffort1Count",
  "decelEffort1Count",
  "speedZone1Distance",
  "speedZone2Distance",
  "speedZone3Distance",
  "speedZone4Distance",
  "speedZone5Distance",
]
